import Donut from "./Donut"
import TokenomicsInfo from "./TokenomicsInfo"

function Tokenomics() {
  return (
    <div 
    
    className="flex flex-col justify-evenly  items-center h-full w-full relative z-100 p-4">
      <div className="flex flex-col items-center justify-center w-full">
      <h2 className="text-slate-100 font-bold text-3xl md:text-6xl mb-4 tracking-wider">TOKENOMICS</h2>
      <p className="text-neutral-200 text-pretty ml-6 sm:ml-0 md:text-wrap font-semibold text-lg md:text-2xl">$PEPE3D coin has a supply of 500 million coins, a testament to its exclusivity and value preservation.</p>
      </div>
      <div className="h-[45vh] w-[45vw] flex justify-center items-center">
        <Donut/>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
        <TokenomicsInfo/>
      </div>
    </div>
  )
}

export default Tokenomics